import operateContentInternal from './ContentOperator';
import EditorViewState from '../store/schema/EditorViewState';
import getSelectedImage from './getSelectedImage';
import {
    PendableFormatState,
    ElementBasedFormatState,
    EditorUndoState,
} from 'roosterjs-editor-types';
import { getElementBasedFormatState } from 'roosterjs-editor-api';
import { getPendableFormatState, getPositionRect } from 'roosterjs-editor-dom';
import { IPoint } from '@fluentui/react/lib/Utilities';

export interface FormatStateResult {
    pendableState: PendableFormatState;
    elementBasedState: ElementBasedFormatState;
    undoState: EditorUndoState;
    cursorPosition: IPoint;
}

export default function getFormatStates(
    viewState: EditorViewState,
    includeCursorPosition: boolean
): FormatStateResult {
    let result: FormatStateResult = null;

    operateContentInternal(
        viewState,
        editor => {
            let cursorPosition: IPoint = null;

            if (includeCursorPosition && editor.hasFocus()) {
                const range = editor.getSelectionRange();
                if (range && !range.collapsed) {
                    const focusedPosition = editor.getFocusedPosition();
                    const rect = focusedPosition && getPositionRect(focusedPosition);
                    cursorPosition = rect && {
                        x: rect.left,
                        y: rect.top,
                    };
                }
            }

            const elementBasedState = getElementBasedFormatState(editor);
            elementBasedState.canAddImageAltText = !!getSelectedImage(viewState);

            result = {
                pendableState: getPendableFormatState(editor.getDocument()),
                elementBasedState,
                undoState: editor.getUndoState(),
                cursorPosition,
            };
        },
        null
    );

    return result;
}
